/* eslint-disable(prettier/prettier) */
// 🔴 DO NOT EDIT — This file is generated.

import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
const CheckSvg = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={19}
      height={18}
    >
      <path fill="currentColor" d="M.5 0h18v18H.5z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="m7.663 11.637 6.478-6.48a.556.556 0 0 1 .802 0q.175.175.175.402a.55.55 0 0 1-.175.4l-6.806 6.807a.65.65 0 0 1-.474.203.65.65 0 0 1-.475-.203L4.057 9.635a.54.54 0 0 1-.165-.398.56.56 0 0 1 .176-.404.55.55 0 0 1 .401-.175q.227 0 .401.175z"
        fill="currentColor"
      />
    </g>
  </svg>
)
const ForwardRef = forwardRef(CheckSvg)
export default ForwardRef
